module.exports = __webpack_public_path__ + "img/offer-mainstream.13dfe4b1.jpg";